import { render, staticRenderFns } from "./CoveragePageFormula.vue?vue&type=template&id=3fbf38e4"
import script from "./CoveragePageFormula.vue?vue&type=script&lang=js"
export * from "./CoveragePageFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports